/**
 * Fabrix Wishlist — localStorage-based save/unsave functionality.
 */
(function () {
  const STORAGE_KEY = 'fabrix-wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch {
      // Storage full or unavailable
    }
  }

  function isInWishlist(handle) {
    return getWishlist().includes(handle);
  }

  function toggleWishlist(handle) {
    let list = getWishlist();
    if (list.includes(handle)) {
      list = list.filter((h) => h !== handle);
    } else {
      list.unshift(handle);
    }
    saveWishlist(list);
    return list.includes(handle);
  }

  function updateAllButtons() {
    document.querySelectorAll('.fabrix-save-btn').forEach((btn) => {
      const handle = btn.dataset.productHandle;
      if (isInWishlist(handle)) {
        btn.classList.add('fabrix-save-btn--active');
        btn.setAttribute('aria-pressed', 'true');
      } else {
        btn.classList.remove('fabrix-save-btn--active');
        btn.setAttribute('aria-pressed', 'false');
      }
    });
  }

  function init() {
    updateAllButtons();

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.fabrix-save-btn');
      if (!btn) return;
      e.preventDefault();
      const handle = btn.dataset.productHandle;
      if (!handle) return;
      toggleWishlist(handle);
      updateAllButtons();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
